import { render, staticRenderFns } from "./Teachers.vue?vue&type=template&id=6c6dcc7f"
import script from "./Teachers.vue?vue&type=script&lang=ts"
export * from "./Teachers.vue?vue&type=script&lang=ts"
import style0 from "./Teachers.vue?vue&type=style&index=0&id=6c6dcc7f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports